import { __decorate, __extends } from "tslib";
import React, { Component } from 'react';
import styles from './MarketADBanner.module.less';
import { app as api } from '@ekuaibao/whispered';
import { uniq } from 'lodash';
import { Carousel } from 'antd';
import { connect } from '@ekuaibao/mobx-store';
import { showMessage } from '@ekuaibao/show-util';
import { toJS } from 'mobx';
import { permissionKeys } from '@ekuaibao/lib/lib/enums';
import { getV as get } from '@ekuaibao/lib/lib/help';
var bannerKey = 'PcBanner';
var MarketADBanner = (function (_super) {
    __extends(MarketADBanner, _super);
    function MarketADBanner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hide: true,
            close: false,
            closedTypes: [],
            closedIds: [],
            settingValue: '',
            appletSetting: '',
            responseValue: undefined,
            dataSource: undefined
        };
        _this.fnConfigBanner = function () {
            api.store.dispatch('@marketADBanner/changeValueForMarketBannerHadInit')();
            var inProductionMode = process.env.NODE_ENV === 'production';
            var appKey = inProductionMode
                ? 'fd45750dd020da8e338817dce4741269'
                : '7fe8e836921493cba9afc767c65c7233';
            var appSecret = inProductionMode
                ? '570ed01958392b2b1f3eeac69a59026a'
                : '1f4279f517a8d007cbafff0942bfe6d2';
            window.masdk && window.masdk.init({
                debug: false,
                appKey: appKey,
                appSecret: appSecret
            });
        };
        _this.fnFetchBanner = function () {
            var _a, _b;
            var userInfo = api.getState('@common.userinfo');
            var powersCodeMap = api.getState('@common').powers.powerCodeMap;
            var permissions = get(userInfo, 'data.permissions', []);
            var corporation = userInfo.corporation, staff = userInfo.staff;
            var type = _this.props.type;
            var setting = toJS(_this.props.setting);
            var permissionArr = permissions.map(function (permission) { return permissionKeys[permission]; });
            var permissionsValue = permissionArr.join('|');
            var rolesArr = [];
            var roles = get(staff, 'roles.values', []);
            roles.forEach(function (role) {
                rolesArr.push(get(role, 'roleDef.name'));
            });
            var rolesValue = rolesArr.join('|');
            var city = get(corporation, 'address', '');
            var corporationName = get(corporation, 'name', '');
            var powersList = api.getState('@common').powers.powersList || [];
            var powerInfo = powersList === null || powersList === void 0 ? void 0 : powersList.find(function (item) { return item.powerCode === '110101'; });
            var baseStaffsCount = ((_a = powerInfo === null || powerInfo === void 0 ? void 0 : powerInfo.chargeInfo) === null || _a === void 0 ? void 0 : _a.usedPeopleCount) || 2;
            var staffsCount = baseStaffsCount;
            var chargeCodes = powersCodeMap && powersCodeMap.join('|');
            var closedIds;
            var closedTypes;
            var responseValue = get(setting, 'value', '');
            var settingValue = get(setting, 'value.setting', '');
            var appletSetting = get(setting, 'value.appletSetting', '');
            if (settingValue && type === 'firstPage') {
                settingValue = JSON.parse(settingValue);
                closedIds = (settingValue.closedIds || ['', '']).join('|');
                closedTypes = (settingValue.closedTypes || ['', '']).join('|');
            }
            else {
                closedIds = '|';
                closedTypes = '|';
            }
            var platform = window.__PLANTFORM__;
            var isStandalone = IS_STANDALONE ? 'true' : 'false';
            var params = {
                permissionsValue: permissionsValue,
                rolesValue: rolesValue,
                city: city,
                corporationName: corporationName,
                staffsCount: staffsCount,
                chargeCodes: chargeCodes,
                platform: platform,
                isStandalone: isStandalone,
                closedIds: closedIds,
                closedTypes: closedTypes
            };
            var userid = get(staff, 'userId', 'noUserId');
            if (userid !== 'noUserId') {
                userid = userid.replace(/-/g, '_');
            }
            var context = _this;
            window.masdk && ((_b = window.masdk.banner({
                userid: userid,
                goBack: false,
                positionKey: bannerKey,
                conditions: params,
            })) === null || _b === void 0 ? void 0 : _b.then(function (list) {
                if (list.error || !list.data) {
                    if (type === 'all') {
                        showMessage.info(i18n.get('您当前没有收到系统推送'));
                    }
                    api.store.dispatch('@marketADBanner/changeMarketBannerType')('');
                }
                else {
                    if (context.props.type === 'firstPage') {
                        api.store.dispatch('@marketADBanner/changeBannerStatusInFirstPage')(true);
                    }
                    var data = get(list, 'data', []);
                    var arr_1;
                    var obj_1 = {};
                    var closedIdsArr_1 = [];
                    var closedTypesArr_1 = [];
                    data.forEach(function (el) {
                        var url = el.url;
                        arr_1 = url.split('?')[1] || [];
                        arr_1 = arr_1.split('&');
                        arr_1.forEach(function (item) {
                            var arr2 = item.split('=');
                            obj_1[arr2[0]] = decodeURIComponent(arr2[1]);
                        });
                        closedIdsArr_1.push(obj_1.id);
                        closedTypesArr_1.push(obj_1.type);
                    });
                    context.setState({
                        dataSource: data,
                        hide: false,
                        closedIds: closedIdsArr_1,
                        closedTypes: closedTypesArr_1,
                        settingValue: settingValue,
                        appletSetting: appletSetting,
                        responseValue: responseValue
                    });
                }
            }));
        };
        _this.fnClose = function () {
            _this.setState({ close: true }, function () {
                setTimeout(function () {
                    _this.setState({ hide: true });
                    api.store.dispatch('@marketADBanner/changeMarketBannerType')('');
                }, 500);
            });
        };
        _this.handleCloseTypes = function () {
            var _a = _this.state, closedIds = _a.closedIds, closedTypes = _a.closedTypes;
            var _b = _this.state, responseValue = _b.responseValue, _c = _b.settingValue, settingValue = _c === void 0 ? {} : _c, appletSetting = _b.appletSetting;
            if (settingValue.closedIds) {
                closedIds = uniq(settingValue.closedIds.concat(closedIds));
            }
            if (settingValue.closedTypes) {
                closedTypes = uniq(settingValue.closedTypes.concat(closedTypes));
            }
            else {
                closedTypes = uniq(closedTypes);
            }
            var setting = { closedIds: closedIds, closedTypes: closedTypes };
            var method = responseValue ? 'put' : 'post';
            api.store.dispatch("@marketADBanner/" + method + "BoxSetting")({ setting: JSON.stringify(setting), appletSetting: appletSetting });
            _this.fnClose();
        };
        _this.handleCloseIds = function () {
            var type = _this.props.type;
            if (type !== 'all') {
                var closedIds = _this.state.closedIds;
                var _a = _this.state, responseValue = _a.responseValue, _b = _a.settingValue, settingValue = _b === void 0 ? {} : _b, appletSetting = _a.appletSetting;
                if (settingValue.closedIds) {
                    closedIds = uniq(settingValue.closedIds.concat(closedIds));
                }
                var setting = { closedIds: closedIds };
                if (settingValue.closedTypes) {
                    setting['closedTypes'] = settingValue.closedTypes;
                }
                var method = responseValue ? 'put' : 'post';
                api.store.dispatch("@marketADBanner/" + method + "BoxSetting")({ setting: JSON.stringify(setting), appletSetting: appletSetting });
            }
            _this.fnClose();
        };
        _this.renderContent = function () {
            var dataSource = _this.state.dataSource;
            if (!dataSource) {
                return null;
            }
            return (React.createElement(Carousel, { autoplay: true, dots: true }, dataSource.map(function (el) {
                var image = el.image, url = el.url;
                return (React.createElement("img", { src: image, onClick: function () { return api.emit('@vendor:open:link', url); } }));
            })));
        };
        return _this;
    }
    MarketADBanner.prototype.componentWillUnmount = function () {
        if (this.props.type === 'firstPage') {
            api.store.dispatch('@marketADBanner/changeBannerStatusInFirstPage')(false);
        }
        else if (this.props.type === 'all' && !this.state.close) {
            api.store.dispatch('@marketADBanner/changeMarketBannerType')('');
        }
    };
    MarketADBanner.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.type === 'firstPage') {
            var pathname = api.history.location.pathname;
            if (pathname && !!~pathname.indexOf('/datalink/')) {
                return;
            }
        }
        var marketBannerHadInit = this.props.marketBannerHadInit;
        if (!marketBannerHadInit) {
            if (window.masdk) {
                this.fnConfigBanner();
                setTimeout(function () { return _this.fnFetchBanner(); }, 2000);
            }
        }
        else {
            if (window.masdk) {
                this.fnFetchBanner();
            }
        }
    };
    MarketADBanner.prototype.render = function () {
        var type = this.props.type;
        var _a = this.state, close = _a.close, hide = _a.hide;
        var wrapperStyle = hide ? { width: 0, height: 0 } : {};
        var className = close ? styles['bannerBox'] + ' ' + styles['bannerBox-checked'] : styles['bannerBox'];
        return (React.createElement("div", { id: "bannerBox", className: className, style: wrapperStyle },
            React.createElement("div", { "position-key": bannerKey, style: { width: 0, height: 0 } }),
            this.renderContent(),
            React.createElement("div", { className: "bannerBox-btn-wrap" },
                type !== 'all' && React.createElement("span", { className: "bannerBox-btn", onClick: this.handleCloseTypes }, '不感兴趣'),
                React.createElement("span", { className: "bannerBox-btn", onClick: this.handleCloseIds }, '关闭'))));
    };
    MarketADBanner = __decorate([
        connect(function (store) { return ({
            marketBannerHadInit: store.states['@marketADBanner'].marketBannerHadInit,
            setting: store.states['@marketADBanner'].setting
        }); })
    ], MarketADBanner);
    return MarketADBanner;
}(Component));
export default MarketADBanner;
